import { render, staticRenderFns } from "./token.template.vue?vue&type=template&id=5b23446f&scoped=true&"
var script = {}
import style0 from "./token.template.vue?vue&type=style&index=0&id=5b23446f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b23446f",
  null
  
)

export default component.exports